import { CheckSquare, Clock, Link2, Package, Users } from "lucide-react";

const KIND = { task: ["Task", CheckSquare], partner_query: ["Partner query", Users], parcel_query: ["Parcel query", Package] };
const LABEL = { pending: "Open", in_progress: "In progress", completed: "Done", open: "Open", solved: "Solved" };

const age = (h) => (h < 1 ? `${Math.round(h * 60)}m` : h < 48 ? `${Math.round(h)}h` : `${Math.round(h / 24)}d`);

export const LinkChip = ({ l, onOpen }) => {
  if (!l) return null;
  const [k, I] = KIND[l.kind] || ["Item", Link2];
  if (l.missing) return <span className="mt-1.5 inline-flex items-center gap-1 rounded-md bg-slate-100 px-2 py-1 text-[11px] text-slate-500">{k} was deleted</span>;
  const tone = l.done ? "border-emerald-200 bg-emerald-50 text-emerald-800" : l.late ? "border-rose-300 bg-rose-50 text-rose-700" : "border-amber-200 bg-amber-50 text-amber-800";
  return (
    <button onClick={onOpen} className={`mt-1.5 inline-flex max-w-full items-center gap-1.5 rounded-md border px-2 py-1 text-left text-[11px] ${tone}`} data-testid={`chat-link-chip-${l.id}`}
      title={l.done ? "Finished" : l.late ? "Past the time limit" : `Time limit ${l.kind === "task" && l.due ? `due ${l.due}` : `${l.sla_h}h`}`}>
      <I className="h-3.5 w-3.5 shrink-0" /><b className="shrink-0">{k}</b><span className="truncate">{l.title}</span>
      <span className="shrink-0 rounded bg-white/70 px-1 font-semibold" data-testid={`chat-link-status-${l.id}`}>{LABEL[l.status] || l.status}</span>
      {!l.done && <span className={`inline-flex shrink-0 items-center gap-0.5 ${l.late ? "animate-pulse font-bold" : ""}`}><Clock className="h-3 w-3" />{age(l.age_h)}</span>}
    </button>
  );
};

export const linkPanel = { task: "tasks", partner_query: "queries", parcel_query: "order_register" };
